import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { signup } from '../services/api';

function Signup() {
  const [formData, setFormData] = useState({
    storeName: '',
    address: '',
    phone: '',
    chairs: '',
    customers: ''
  });
  const [submitted, setSubmitted] = useState(false);
  const routerLocation = useLocation();

  useEffect(() => {
    if (routerLocation.state?.selectedChairs) {
      setFormData(prev => ({ ...prev, chairs: routerLocation.state.selectedChairs }));
    }
  }, [routerLocation.state]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await signup(formData);
      if (response.success) {
        // Store the store_id in localStorage for later use
        if (response.store_id) {
          localStorage.setItem('store_id', response.store_id);
        }
        setSubmitted(true);
      } else {
        alert('Error signing up: ' + response.error);
      }
    } catch (error) {
      alert('Error: ' + error.message);
    }
  };

  if (submitted) {
    return (
      <div className="container mt-5">
        <div className="row justify-content-center">
          <div className="col-lg-6">
            <div className="text-center mb-4">
              <h1 className="display-5 fw-light text-muted">Request Received.</h1>
              <p className="lead text-muted">We’re preparing your tailored replenishment plan.<br />You’ll receive a breakdown of projected costs and delivery timing shortly.<br />No commitment until you approve.</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container mt-5">
      <div className="row justify-content-center">
        <div className="col-lg-6">
          <div className="text-center mb-4">
            <h1 className="display-5 fw-light text-muted">Get Started</h1>
            <p className="lead text-muted">Tell us about your business</p>
          </div>
          <div className="card border-0 shadow-sm">
            <div className="card-body p-4">
              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label className="form-label text-muted">Store Name</label>
                  <input name="storeName" value={formData.storeName} onChange={handleChange} placeholder="Enter your store name" required className="form-control border-0 bg-light" />
                </div>
                <div className="mb-3">
                  <label className="form-label text-muted">Address</label>
                  <input name="address" value={formData.address} onChange={handleChange} placeholder="Enter your address" required className="form-control border-0 bg-light" />
                </div>
                <div className="mb-3">
                  <label className="form-label text-muted">Phone Number</label>
                  <input name="phone" value={formData.phone} onChange={handleChange} placeholder="Enter your phone number" required className="form-control border-0 bg-light" />
                </div>
                <div className="mb-3">
                  <label className="form-label text-muted">Number of Chairs</label>
                  <input name="chairs" type="number" value={formData.chairs} onChange={handleChange} placeholder="How many chairs?" required className="form-control border-0 bg-light" />
                </div>
                <div className="mb-4">
                  <label className="form-label text-muted">Estimated Monthly Customers</label>
                  <input name="customers" type="number" value={formData.customers} onChange={handleChange} placeholder="How many customers per month?" required className="form-control border-0 bg-light" />
                </div>
                <div className="text-center">
                  <button type="submit" className="btn btn-outline-primary btn-lg px-5 py-3 rounded-pill">
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Signup;
